import { PhoneCallRequestData } from '@bupa-monorepo/shared-types/view-types';
import { useMutation } from '@tanstack/react-query';
import { sendPhoneCallRequest } from '../api/callback-request.api';

export const useCallbackMutation = () => {
  return useMutation({
    mutationFn: (payload: PhoneCallRequestData) =>
      sendPhoneCallRequest(payload),
  });
};
